export type SimpleObject = { [key: string]: any };
export type SimpleStringObject = { [key: string]: string };
export type CustomObject<T> = { [key: string]: T };

export interface PostgresInterval {
  years?: number;
  months?: number;
  days?: number;
  hours?: number;
  minutes?: number;
  seconds?: number;
  milliseconds?: number;
  microseconds?: number;
}

export enum ImageFormats {
  Png = 'png',
  Jpg = 'jpeg'
}

export interface UserType extends BasicEntity {
  userTypeId: string;
  userTypeName: string;
}

export interface UserOccupation extends BasicEntity {
  userOccupationId: string;
  userOccupationName: string;
}

export enum UserAuthProvider {
  internal = 'Interno',
  google = 'Google'
}

export enum UserTypeValues {
  Admin = 'ADMIN',
  Interno = 'INTERNO'
}

export enum EstadoSimulacion {
  inProgress = 'En progreso',
  finished = 'Finalizada',
  error = 'Error',
  onStandby = 'En Espera'
}

export interface BasicEntity {
  _id: string;
}

export interface User extends BasicEntity {
  userAccountId: string;
  userUsername: string;
  userAccountEmail: string;
  userPassword: string;
  userAccountFirstname: string;
  userAccountLastname: string;
  userAccountCompanyName: string;
  userOccupationName: string;
  userAccountTypeId: string;
  userTypeName: UserTypeValues;
  userIsActive: boolean;
  createdAt: boolean;
  updatedAt: boolean;
  cantidadSimulaciones: string;
  providerName: string;
}

export interface UserType extends BasicEntity {
  userAccountTypeId: string;
  userTypeName: string;
  createdAt: boolean;
  updatedAt: boolean;
}

export interface Studies extends BasicEntity {
  nombreSimulacion: string;
  userTypeName: string;
  tipoSimulacion: string;
  fechaCreacion: string;
  estadoSimulacion: string;
  archivoResultado: string;
  ver: any;
  descargar: any;
}

export interface UnifiedStudy extends BasicEntity {
  tablaOrigen: 'simulacion' | 'estudio_conexion_gd';
  tipoEstudio: string;
  visibilidad: string;
  nombre: string;
  alimentadorId: number;
  alimentadorNombre: string;
  estado: string;
  estadoId: number;
  estadoMitigacion: string | null;
  estadoMitigacionId: number | null;
  createdAt: string;
  tipoGd: string | null;
  potenciaKw: number | null;
  archivoResultado: string | null;
}

export interface AdminStudies extends BasicEntity {
  tipoSimulacion: string;
  fechaCreacion: string;
  nombreSimulacion: string;
  empresaId: string;
  alimentadorId: string;
}

type ConfigType = {
  checked: boolean;
  min: number;
  max: number;
};

export type StudyConfigType = {
  pvResidencial: ConfigType;
  batResidencial: ConfigType;
  /** Penetración BESS % sobre cargas con PV (0–100, paso 10); si batResidencial no está marcado se envía 0 */
  penetracionBateriasPct: number;
  tapDinamico: boolean;
  reactivosPv: boolean;
  bateriasResidenciales: boolean;
  evResidencialCheck: boolean;
};

export type StudyType = 'public-study' | 'private-study';
